__turbopack_context__.v({
  "active": "_eWvUa_active",
  "footerMenu": "_eWvUa_footerMenu",
  "menuList": "_eWvUa_menuList",
  "menuListItem": "_eWvUa_menuListItem",
  "menuWrapper": "_eWvUa_menuWrapper",
  "visible": "_eWvUa_visible",
});
